import { Pipe, PipeTransform } from '@angular/core';
import { ButtonDropdownItem } from '../components';

@Pipe({ name: 'fullPathBtnUrl', standalone: true })
export class GetButtonFullRoutePathPipe implements PipeTransform {
  transform(partialPath: string, currentUrl: string) {
    return partialPath ? `${currentUrl}/${partialPath}` : undefined;
  }
}

@Pipe({ name: 'buttonDropdownClass', standalone: true })
export class GetButtonDropdownClassPipe implements PipeTransform {
  transform(index: number, item: ButtonDropdownItem) {
    return `li${index} ${item.disabled ? 'disabled' : ''}`;
  }
}
